/** @jsx jsx */
import { css, jsx } from '@emotion/react';
const labelTextStyles = css({
  alignSelf: 'center',
  gridArea: '1 / 2 / 2 / 3'
});
export default function LabelText({
  children
}) {
  return jsx("span", {
    css: labelTextStyles
  }, children);
}